import React, { memo } from "react";
import "./styles.scss";

const StyledTimeField = ({
  onChange = () => {},
  value = "",
  label = "",
  marginBottom = 0,
  errorMessage = "",
}) => {
  return (
    <div
      className="calender-select-field"
      style={{ padding: "0px", marginBottom: marginBottom }}
    >
      {label.length && <div className="label-styles">{label}</div>}
      <input
        type="time"
        value={value}
        class="form-control"
        id="date"
        style={{
          background: "white",
        }}
        onChange={onChange}
      />
      {errorMessage?.length ? (
        <div style={{ fontSize: "11px", fontWeight: 500, color: "red" }}>
          {errorMessage}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(StyledTimeField);
